import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { initializeIcons } from '@fluentui/react';
import App from './App';
import { initAuth } from './auth';
import './index.css';
import { ENVIRONMENT_LABEL } from './config';

if (ENVIRONMENT_LABEL) {
  document.title = `[${ENVIRONMENT_LABEL}] ${document.title}`;
}

// Inside SharePoint the page provides Fluent UI's icons; a standalone site loads them itself.
initializeIcons();

const root = createRoot(document.getElementById('root')!);

initAuth()
  .then(account => root.render(<App account={account} />))
  .catch((error: unknown) => {
    console.error(error);
    root.render(
      <main className="landing">
        <p>Sign-in could not start: {String((error as Error)?.message ?? error)}</p>
      </main>
    );
  });
